export default {"src":"/education/_next/static/media/cancel-btn.8886a2cf.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};